export default __webpack_public_path__ + "static/propertybannerTable-e5a1b7fa58ccf5d6ed7e4d4274bca5ea.jpg";